<div class="api-viewer-container">
  <!-- Loading overlay for entire viewport -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner-container">
      <div class="spinner"></div>
      <p>Loading API specification...</p>
    </div>
  </div>
  
  <div class="content-section" *ngIf="apiInfo?.content" [class.fade-in]="!loading">
    <div class="version-selector-wrapper" *ngIf="availableVersions.length > 0">
      <app-version-selector
        [versions]="availableVersions"
        [selectedVersionId]="currentVersionId"
        (versionChange)="onVersionChange($event)">
      </app-version-selector>
    </div>
    <div class="swagger-content" [class.loading-state]="loading">
      <div #swaggerContainer id="swagger-ui" ></div>
    </div>
  </div>
</div>
<div class="error" *ngIf="error"> Error loading API specification: {{ error }}</div>